export default "__VITE_ASSET__f883ec95__"